import { render, staticRenderFns } from "./error.vue?vue&type=template&id=feade53a&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feade53a')) {
      api.createRecord('feade53a', component.options)
    } else {
      api.reload('feade53a', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=feade53a&", function () {
      api.rerender('feade53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/error.vue"
export default component.exports